// extracted by mini-css-extract-plugin
export var container = "style-module--container--74091";
export var imgWrap = "style-module--img-wrap--338b3";
export var info = "style-module--info--a1924";
export var prof = "style-module--prof--08889";
export var speakers = "style-module--speakers--5d925";